import moment from "moment"

export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

/** "3 minutes ago", "2 days ago" — null/invalid → "" */
export function timeAgo(date) {
    if (!date) return ""
    const m = moment(date)
    if (!m.isValid()) return ""
    return m.fromNow()
}

/**
 * Presence label for a user: online → texts.online ("Online"), otherwise
 * "Last online 3 hours ago" (texts.lastOnline with {ago}), or "" if never seen.
 */
export function presenceLabel({ online, lastSeen }, texts = {}) {
    if (online) return texts.online || "Online"
    const ago = timeAgo(lastSeen)
    if (!ago) return texts.neverOnline || ""
    return (texts.lastOnline || "Last online {ago}").replace("{ago}", ago)
}
